import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseChannel, RChannel} from './channelModel';
import {parseInbox, RInbox} from './inboxModel';

/*
 * Runtime type.
 */

const RSearchInboxesDirty = t.readonly(
  t.type({
    limit: t.number,
    inboxes: t.readonlyArray(RInbox),
    channels: t.readonlyArray(RChannel),
  }),
);

/*
 * Type.
 */

export interface SearchInboxesModel extends t.TypeOf<typeof RSearchInboxesDirty> {}
export const RSearchInboxes = t.clean<SearchInboxesModel>(RSearchInboxesDirty as any);

/*
 * IO methods.
 */

export function parseSearchInboxes(src: any): SearchInboxesModel {
  return {
    limit: src.limit,
    inboxes: src.inboxes && src.inboxes.map(parseInbox),
    channels: (src.channels && src.channels.map(parseChannel)) || [],
  };
}

/*
 * API type.
 */

export const ApiSearchInboxes = makeApiType('searchInboxes', RSearchInboxes, parseSearchInboxes);
